import dayjs from "dayjs"
import { useEffect } from "react"

import usePrivacyPolicyUpdateModalStore from "./usePrivacyPolicyUpdateModalStore"
import { usePrivacyPolicyAgreementLinksQuery } from "../../../networking/agreementLinks/queries"
import { useUserQuery } from "../../../networking/queries"

const usePrivacyPolicyUpdate = () => {
  const { onOpen } = usePrivacyPolicyUpdateModalStore()
  const { user } = useUserQuery()
  const {
    data: privacyPolicyAgreementLinks,
    isLoading: isLoadingPrivacyPolicyAgreementLinks,
  } = usePrivacyPolicyAgreementLinksQuery()

  useEffect(() => {
    if (
      !isLoadingPrivacyPolicyAgreementLinks &&
      privacyPolicyAgreementLinks &&
      privacyPolicyAgreementLinks.length > 0 &&
      user?.date_joined &&
      dayjs(user.date_joined).isBefore(dayjs("2025-06-10"))
    )
      onOpen()
  }, [
    user,
    onOpen,
    isLoadingPrivacyPolicyAgreementLinks,
    privacyPolicyAgreementLinks,
  ])
}

export default usePrivacyPolicyUpdate
